/* eslint-disable react/require-default-props */

export function GameFlag({ color, text }: { color: string, text: string }) {
  return (
    <div className="relative">
      <svg
        width="55"
        height="23"
        viewBox="0 0 55 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
        focusable="false"
      >
        <g id="7acb1774">
          <path
            id="2bfa26f5"
            style={{ mixBlendMode: 'multiply' }}
            d="M19.5 23C29.7173 23 38 18.0751 38 12C38 5.92487 29.7173 1 19.5 1C9.28273 1 1 5.92487 1 12C1 18.0751 9.28273 23 19.5 23Z"
            fill="url(#paint0_radial_7280_4334)"
          />
          <path
            id="1421be60"
            style={{ mixBlendMode: 'multiply' }}
            d="M31 23C40.9411 23 49 18.0751 49 12C49 5.92487 40.9411 1 31 1C21.0589 1 13 5.92487 13 12C13 18.0751 21.0589 23 31 23Z"
            fill="url(#paint1_radial_7280_4334)"
          />
          <path
            id="95128860"
            style={{ mixBlendMode: 'multiply' }}
            d="M18.8721 0H1V5H19L18.8721 0Z"
            fill="url(#paint2_radial_7280_4334)"
          />
          <path
            id="f65f8668"
            style={{ mixBlendMode: 'multiply' }}
            d="M48.8535 0H28V5H49L48.8535 0Z"
            fill="url(#paint3_radial_7280_4334)"
          />
          <path
            id="c82240d6"
            d="M0.770264 0.631836H54.4684V14.1061C54.4684 18.928 49.7629 22.8436 43.9683 22.8436H11.2704C5.47576 22.8436 0.770264 18.928 0.770264 14.1061V0.631836Z"
            fill={color}
          />
        </g>
        <defs>
          <radialGradient id="paint0_radial_7280_4334" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(19.6687 11.915) rotate(90) scale(10.2434 18.4961)">
            <stop offset="0.43" stopColor={color} />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="paint1_radial_7280_4334" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(31.1588 11.9077) rotate(90) scale(10.2434 17.9962)">
            <stop offset="0.43" stopColor={color} />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="paint2_radial_7280_4334" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(10.3208 -0.786909) rotate(-90) scale(4.88554 9.30255)">
            <stop stopColor={color} />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </radialGradient>
          <radialGradient id="paint3_radial_7280_4334" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(38.8756 57.2835) rotate(-90) scale(4.88554 10.853)">
            <stop stopColor={color} />
            <stop offset="1" stopColor="white" stopOpacity="0" />
          </radialGradient>
          <linearGradient id="35c416e1" x1="25.1212" y1="-1.94835" x2="25.1212" y2="17.213" gradientUnits="userSpaceOnUse">
            <stop stopColor={color} />
            <stop offset="0.91" stopColor={color} />
          </linearGradient>
        </defs>
      </svg>
      <p className="text-xs text-hsecondary-50 font-medium font-text absolute top-[3px] left-10 w-full text-center truncate">
        {text}
      </p>
    </div>
  );
}
